var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.4062,
    y: 19.0011,
    width: 42.1875,
    height: 38,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5005 69.667C54.7599 69.667 68.7505 55.4898 68.7505 38.0003C68.7505 20.5108 54.7599 6.33368 37.5005 6.33368C20.2411 6.33368 6.25049 20.5108 6.25049 38.0003C6.25049 55.4898 20.2411 69.667 37.5005 69.667ZM48.5505 26.803C49.1373 26.2092 49.9328 25.876 50.7621 25.8766C51.5913 25.8772 52.3864 26.2116 52.9724 26.8062C53.5583 27.4008 53.8872 28.2069 53.8866 29.0473C53.886 29.8876 53.556 30.6932 52.9692 31.287L35.3036 49.1882L35.2911 49.2008C35.0016 49.4959 34.6573 49.7301 34.2782 49.8899C33.899 50.0497 33.4924 50.132 33.0817 50.132C32.6711 50.132 32.2645 50.0497 31.8853 49.8899C31.5062 49.7301 31.1619 49.4959 30.8724 49.2008L30.8599 49.1882L22.0317 40.2423C21.7333 39.9502 21.4952 39.6008 21.3314 39.2145C21.1676 38.8281 21.0814 38.4126 21.0778 37.9921C21.0742 37.5716 21.1533 37.1547 21.3104 36.7655C21.4675 36.3763 21.6996 36.0228 21.993 35.7254C22.2864 35.4281 22.6353 35.193 23.0194 35.0337C23.4034 34.8745 23.8149 34.7944 24.2299 34.7981C24.6448 34.8017 25.0549 34.8891 25.4361 35.055C25.8174 35.221 26.1622 35.4622 26.4505 35.7647L33.0817 42.4812L48.5505 26.8062V26.803Z",
    fill: "#459BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.480ba46f29430f29c01a98a12e919801.svg";
export { ForwardRef as ReactComponent };